import * as React from 'react';
import SearchContext from './SearchContext';

type Props = {
  children: React.ReactNode;
};
const SearchProvider = ({ children }: Props) => {
  const [mapViewport, setMapViewport] = React.useState({});
  const [mapViewportDefault, setMapViewportDefault] = React.useState({});
  const [highlightItemId, setHighlightItemId] = React.useState(null);
  return (
    <SearchContext.Provider
      value={{
        mapViewport,
        setMapViewport,
        mapViewportDefault,
        setMapViewportDefault,
        highlightItemId,
        setHighlightItemId,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export default SearchProvider;
